'use strict';

const $ = require('jquery');
const _ = require('underscore');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const ElementRepository = require('system/domain/repository/element');
const UnitRepository = require('system/domain/repository/unit');
const Template = require('system/ui/template/value/view.hbs');
const RealTemplate = require('system/ui/template/value/real.hbs');
const IntegerTemplate = require('system/ui/template/value/integer.hbs');
const StringTemplate = require('system/ui/template/value/string.hbs');
const BooleanTemplate = require('system/ui/template/value/boolean.hbs');
const TypeNotFoundTemplate = require('system/ui/template/value/not-found.hbs');
const EditTemplate = require('system/ui/template/value/edit-view.hbs');
const RealEditTemplate = require('system/ui/template/value/real-edit.hbs');
const IntegerEditTemplate = require('system/ui/template/value/integer-edit.hbs');
const StringEditTemplate = require('system/ui/template/value/string-edit.hbs');
const BooleanEditTemplate = require('system/ui/template/value/boolean-edit.hbs');
const TypeNotFoundEditTemplate = require('system/ui/template/value/not-found-edit.hbs');

const isPrimitiveValueType = function(valueType) {
    const values = valueType.get('values');
    if(!values || values.length != 1) {
        return false;
    }

    const value = values[0];
    // 自己参照していれば Primitive
    return valueType.id == value.type;
};

const ValuePropertyView = Mn.View.extend({
    template: Template,
    className: 'value-property form-inline',
    ui: {
        name: '.value-name',
        delete: '.value-delete'
    },
    events: {
        'input @ui.name': 'changeName',
        'click @ui.delete': 'delete'
    },
    regions: {
        values: '.value-type-values'
    },

    initialize: function(params) {
        this._context = params.context;
        this._edit = params.edit;
        this._depth = params.depth ? params.depth : 0;
        const data = _.clone(this.model.get('data'));
        this._data = _.extend(data ? data : {}, params.data);
    },

    serializeData: function() {
        const j = this.model.toJSON();
        const type = this.getType();

        if(type) {
            j.type = type.toJSON();
        }
        j.depth = this._depth;

        return j;
    },

    onRender: function() {
        this.$el.css('margin-left', this._depth * 16 + 'px');
        this.$el.css('font-size', (100 - 10 * this._depth) + '%');
        this.$el.addClass('value-depth-' + this._depth);
    },

    onDomRefresh: function() {
        const collectionView = new ValuePropertyListView({
            collection: new Backbone.Collection(this.getType().get('values')),
            context: this._context,
            depth: this._depth + 1,
            data: this._data,
            edit: this._edit
        });
        this.listenTo(collectionView, 'childview:change:name',
            function(child, data) {
                this.trigger('change:name', data);
            });
        this.listenTo(collectionView, 'childview:change:unit',
            function(child, data) {
                this.trigger('change:unit', data);
            });
        this.listenTo(collectionView, 'childview:change:value',
            function(child, data) {
                const validate = this.getType().get('validate');
                if(validate && !validate(data.data.initial)) {
                    throw 'Invalid value!';
                }
                data.id = this.model.id;
                this.trigger('change:value', data);
            });
        this.listenTo(collectionView, 'childview:delete',
            function(child, data) {
                this.trigger('delete', data);
            });
        this.showChildView('values', collectionView);
    },

    getType: function() {
        return this.getValueTypeByName(this.model.get('type'))
    },

    getValueTypeByName: function(type) {
        return ElementRepository
            .getValueTypes({context: this._context})
            .get(type);
    },

    changeName: function() {
        let name = this.ui.name.val();
        if(name == '') {
            name = null;
        }
        this.trigger('change:name', {
            id: this.model.id,
            name: name
        });
    },

    delete: function() {
        this.trigger('delete', {
            id: this.model.id
        });
    }
});

const ValuePropertyEditView = ValuePropertyView.extend({
    template: EditTemplate
});

const PrimitiveValuePropertyView = ValuePropertyView.extend({
    tagName: function() {
        if(this.options.depth == 0 || this.model.get('name')) {
            return 'div';
        } else {
            return 'span';
        }
    },
    ui: {
        name: '.value-name',
        delete: '.value-delete',
        value: '.value-initial',
        unit: '.value-unit',
        readOnly: 'value-read-only'
    },
    events: {
        'input @ui.name': 'changeName',
        'input @ui.value': 'changeValue',
        'click @ui.delete': 'delete',
        'change @ui.value': 'changeValue',
        'change @ui.unit': 'changeUnit',
        'change @ui.readOnly': 'changeValue'
    },

    serializeData: function() {
        const j = PrimitiveValuePropertyView.__super__.serializeData.call(this);

        j.data = this._data[this.model.id];
        const unit = UnitRepository.getUnits().get(this.model.get('unit'));
        if(unit) {
            j.unit = unit.toJSON();
        }
        j.units = UnitRepository.getUnits().map(function(u) {
            const label = u.getSymbol();
            const value = u.id;
            const selected = j.unit && j.unit.id == u.id;
            return {
                label: label,
                value: value,
                selected: selected
            }
        });

        return j;
    },

    onRender: function() {
        if(this._depth == 0 || this.model.get('name')) {
            this.$el.css('margin-left', this._depth * 16 + 'px');
            this.$el.css('font-size', (100 - 10 * this._depth) + '%');
            this.$el.addClass('value-depth-' + this._depth);
        }

        return this;
    },

    onDomRefresh: function() {
        if($.material)
            $.material.init();
    },

    changeUnit: function() {
        const unit = this.ui.unit.val();
        this.trigger('change:unit', {
            id: this.model.id,
            unit: unit
        });
    },

    onChangeValue: function(value) {
        const type = this.getType();
        const readOnly = this.ui.readOnly.is(':checked');
        if(value !== null) {
            if(!type.get('validate')(value)) {
                throw 'Invalid value!'
            }
        }
        const j = {};
        j[this.model.id] = {
            initial: value,
            readOnly: readOnly
        };
        this.trigger('change:value', {
            id: this.model.id,
            data: j
        });
    }
});

const RealView = PrimitiveValuePropertyView.extend({
    template: RealTemplate
});
const RealEditView = PrimitiveValuePropertyView.extend({
    template: RealEditTemplate,
    changeValue: function() {
        const value = this.ui.value.val();
        if(value == '') {
            this.onChangeValue(null);
        } else {
            this.onChangeValue(parseFloat(value));
        }
    }
});
const IntegerView = PrimitiveValuePropertyView.extend({
    template: IntegerTemplate
});
const IntegerEditView = PrimitiveValuePropertyView.extend({
    template: IntegerEditTemplate,
    changeValue: function() {
        const value = this.ui.value.val();
        if(value == '') {
            this.onChangeValue(null);
        } else {
            this.onChangeValue(parseInt(value));
        }
    }
});
const StringView = PrimitiveValuePropertyView.extend({
    template: StringTemplate
});
const StringEditView = PrimitiveValuePropertyView.extend({
    template: StringEditTemplate,
    changeValue: function() {
        const value = this.ui.value.val();
        if(value == '') {
            this.onChangeValue(null);
        } else {
            this.onChangeValue(value);
        }
    }
});
const BooleanView = PrimitiveValuePropertyView.extend({
    template: BooleanTemplate
});
const BooleanEditView = PrimitiveValuePropertyView.extend({
    template: BooleanEditTemplate,
    changeValue: function() {
        const value = this.ui.value.filter(function() {
            return $(this).is(':checked');
        }).val();
        if(value == 'null') {
            this.onChangeValue(null);
        } else {
            this.onChangeValue(value == 'true');
        }
    }
});

const TypeNotFoundView = ValuePropertyView.extend({
    template: TypeNotFoundTemplate,
    onDomRefresh: function() {},
});

const TypeNotFoundEditView = TypeNotFoundView.extend({
    template: TypeNotFoundEditTemplate
});

const ValuePropertyListView = Mn.CollectionView.extend({
    tagName: 'span',
    childViewOptions: function() {
        return {
            context: this._context,
            depth: this._depth,
            data: this._data,
            edit: this._edit
        }
    },
    initialize: function(params) {
        this._context = params.context;
        this._edit = params.edit;
        this._depth = params.depth ? params.depth : 0;
        this._data = params.data ? params.data : {};
    },

    childView: function(model){
        const type = this.getValueTypeByName(model.get('type'));
        if(this._edit) {
            if(!type) {
                return TypeNotFoundEditView;
            }
            if(isPrimitiveValueType(type)) {
                if(type.id == 'Real') {
                    return RealEditView;
                }
                if(type.id == 'Integer') {
                    return IntegerEditView;
                }
                if(type.id == 'String') {
                    return StringEditView;
                }
                if(type.id == 'Boolean') {
                    return BooleanEditView;
                }
            }
            return ValuePropertyEditView;
        } else {
            if(!type) {
                return TypeNotFoundView;
            }
            if(isPrimitiveValueType(type)) {
                if(type.id == 'Real') {
                    return RealView;
                }
                if(type.id == 'Integer') {
                    return IntegerView;
                }
                if(type.id == 'String') {
                    return StringView;
                }
                if(type.id == 'Boolean') {
                    return BooleanView;
                }
            }
            return ValuePropertyView;
        }
    },
    getValueTypeByName: function(type) {
        return ElementRepository
            .getValueTypes({context: this._context})
            .get(type);
    }
});

module.exports = ValuePropertyListView;



// WEBPACK FOOTER //
// ./system/ui/view/detail/value-property-list.js